document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.metafield-rich_text_field').forEach((faqContent) => {
    const children = Array.from(faqContent.children);
    let i = 0;

    while (i < children.length) {
      const node = children[i];
      const tag = node.tagName.toLowerCase();

      // Check if the tag is a heading (h1-h6)
      if (/^h[1-6]$/.test(tag)) {
        // Create the icon
        const icon = document.createElement('span');
        icon.className = 'faq-icon';
        icon.textContent = '+';
        node.appendChild(icon);
        node.style.cursor = 'pointer';

        // Wrap following siblings in a new div until next heading
        const wrapper = document.createElement('div');
        wrapper.className = 'faq-answer';

        let next = node.nextElementSibling;
        while (next && !/^h[1-6]$/.test(next.tagName.toLowerCase())) {
          const toMove = next;
          next = next.nextElementSibling;
          wrapper.appendChild(toMove);
        }

        node.parentNode.insertBefore(wrapper, next);

        // Toggle handler
        node.addEventListener('click', () => {
          const isOpen = wrapper.classList.contains('open');
          icon.textContent = isOpen ? '+' : '–';
          wrapper.classList.toggle('open');
        });
      }

      i++;
    }
  });
});